<div class="position-relative map-container" *ngIf="displayMap">
    <mgl-map
    [scrollZoom]="false"
    [doubleClickZoom]="false"
    [boxZoom]="false"
    [keyboard]="false"
    (load)="mapReady($event)"
    (move)="displayedCountry = null"
    [minZoom]="2"
    [zoom]="2.25"
    [style]="'mapbox://styles/immersivefactory/clw670j6502b801o0akrwde4r'"
    [center]="mapCenter"
    [dragPan] = "mapMode =='world'"
    >

        <mgl-marker *ngFor="let dot of mapDots['clients']" className="clientDot"  [lngLat]="[dot.lng,dot.lat]">
            <div class="position-relative">
                <div class="map-customer-pin" (click)="displayedCountry = dot.name ? dot.name : null"></div>
                <div class="dotDetails d-flex" *ngIf="dot.name && displayedCountry == dot.name">
                    <div style="background-color: rgba(0,0,0,0.75) !important;color: #ffffff !important;padding: 5px 15px;border-radius: 0.25rem;">{{dot.name}}</div>
                </div>
            </div>
        </mgl-marker>

        <ng-container *ngFor="let dot of mapDots['ifOffices']">
            <mgl-marker style="z-index:2" className="ifDot" *ngIf="mapMode =='europe' && dot.showOnEurope || mapMode =='world' && dot.showOnWorld || true" [lngLat]="[dot.long,dot.lat]">
                <div class="position-relative">
                    <img class="map-pin" src="assets/logo.svg" width="25px" alt="Logo of the Immersive Factory company" title="{{dot.name}}" (click)="clickOnDot(dot)" loading="lazy">
                    <div class="dotDetails">
                        <div style="background-color: rgba(0,0,0,0.75) !important;color: #ffffff !important;padding: 5px 15px;border-radius: 0.25rem;">{{dot.name}}</div>
                    </div>
                </div>
            </mgl-marker>
        </ng-container>



    </mgl-map>

    <div class="mapTooltips rounded">

        <i *ngIf="mapMode =='world'" (click)="changeMapMode('europe')"><app-svg-icon class="cursor-pointer" [src]="'assets/svg/magnifying-glass.svg'" [size]="'17px'"></app-svg-icon></i>
        <i *ngIf="mapMode =='europe'" (click)="changeMapMode('world')"><app-svg-icon class="cursor-pointer" [src]="'assets/svg/globe-stand-solid.svg'" [size]="'17px'"></app-svg-icon></i>

    </div>

    <div class="mapLegend py-2 px-3 rounded">
        <div class="d-flex align-items-center">
            <div class="d-flex justify-content-center mr-2" style="width:20px;">
                <div class="map-customer-pin"></div>
            </div>
            <div>{{'Clients' | translate}}</div>
        </div>
        <div class="d-flex align-items-center">
            <img class="mr-2" src="assets/logo.svg" width="20px" alt="Logo of the Immersive Factory company" title="Immersive Factory logo" loading="lazy">
            <div>{{'Showroom Immersive Factory' | translate}}</div>
        </div>
    </div>
    <div class="map-disabler"></div>
</div>
<div id="map"></div>


<div class="container-fluid officeLine border-bottom py-5">
    <div class="container text-dark">
        <div class="text-center">
            <p class="find-content">{{'Want to find out more?' | translate}}</p>
            <div class="contact-btn bg-immersive mt-2" (click)="showModalContact()">
                <i class="fa fa-envelope"></i><span class="ml-2">{{'Contact us' | translate}}</span>
            </div>
        </div>
    </div>


</div>
<div class="container-fluid officeLine border-bottom py-5">
    <div class="container text-dark">
        <div class="row">
            <div class="pr-3 pl-5 ifOffice col-12 col-md-4 separator" id="ifOffice{{office.id}}" *ngFor="let office of ifOffices">
                <div class="font-weight-normal">
                    <h4 class="font-weight-bold mb-0">{{office.name}}</h4>
                    <div *ngIf="office.logos" class="container mb-1">
                      <div class="row align-items-center">
                        <div class="col-6 pl-0" *ngFor="let logo of office.logos">
                          <a href="{{logo.href}}" target="_blank" rel="noopener nofollow" title="{{logo.title}}">
                            <picture>
                                <source srcset="{{logo.src}}.webp" type="image/webp">
                                <source srcset="{{logo.src}}.png" type="image/png">
                                <img src="{{logo.src}}.png" alt="{{logo.alt}}" title="{{logo.title}}" loading="lazy"/>
                            </picture>
                          </a>
                         </div>
                      </div>
                    </div>
                    <p class="office-fcts mb-1 officeFcts font-italic"><span *ngFor="let fct of office.fcts" class="offictFct">{{fct}}</span></p>
                    <p *ngIf="office.addr" class="mb-1">{{office.addr}}</p>
                    <p class="mb-1">{{office.cp}} {{office.city}}, {{office.country}}</p>
                    <p *ngIf="office['tel']"><a href="tel:{{office['tel']}}" class="text-immersive" title="tel">{{office['tel']}}</a></p>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="text-center py-5">
    <div class="head-icon">
        <app-svg-icon [src]="'assets/svg/landmark-solid.svg'" [size]="'30px'"></app-svg-icon>
    </div>
    <h1 class="text-center font-weight-bold mt-4 text-uppercase mb-0">{{'Our story' | translate}}</h1>
</section>

<section class="bg-immersive text-center py-5">
    <h2 class="mb-3 font-weight-bold text-white">{{'ACTIVE LEARNING APPLIED TO EHS' | translate}}</h2>
    <h4 class="mb-0 text-white"><i>{{'Immersive Learning gives trainees a leading role in their EHS training' | translate}}</i></h4>
</section>

<section class="py-5 business-philosophy">
    <div class="container">
        <h3>{{'Our business philosophy' | translate}}</h3>

        <div class="row">
            <div class="px-5 col-12 col-lg-6">
                <div class="item">
                    <div class="item-icon">
                        <app-svg-icon [src]="'assets/svg/home-solid.svg'" [size]="'50px'"></app-svg-icon>
                    </div>
                    <div class="item-desc">
                        <h4>{{'Mission' | translate}}</h4>
                        <p>{{'Our mission is to drastically reduce accidents at work by proposing to involve all staff through a comprehensive training offer that combines QHSE expertise, immersion and innovation and that allows lasting changes in behavior.' | translate}}</p>
                    </div>
                </div>
            </div>
            <div class="px-5 col-12 col-lg-6">
                <div class="item">
                    <div class="item-icon">
                        <app-svg-icon [src]="'assets/svg/star-solid.svg'" [size]="'50px'"></app-svg-icon>
                    </div>
                    <div class="item-desc">
                        <h4>{{'Goals' | translate}}</h4>
                        <p>{{'Contribute to raise awareness among women and men, whether they are at home or at work, about their Safety, Environment and Social responsabilities and help our customers to stay incident-free and to mitigate professional risks' | translate}}.</p>
                    </div>
                </div>
            </div>
            <div class="px-5 col-12 col-lg-6">
                <div class="item">
                    <div class="item-icon">
                        <app-svg-icon [src]="'assets/svg/gem-solid.svg'" [size]="'50px'"></app-svg-icon>
                    </div>
                    <div class="item-desc">
                        <h4>{{'Values' | translate}}</h4>
                        <p>{{'Create a profitable group, integrating social and environmental concerns in our activities and having a major societal impact: contribute to a drastic reduction in the number of work accidents in companies thanks to cutting-edge training technologies' | translate}}.</p>
                    </div>
                </div>
            </div>
            <div class="px-5 col-12 col-lg-6">
                <div class="item">
                    <div class="item-icon">
                        <app-svg-icon [src]="'assets/svg/POC3.svg'" [size]="'50px'"></app-svg-icon>
                    </div>
                    <div class="item-desc">
                        <h4>{{'Vision' | translate}}</h4>
                        <p>{{'Health, Safety & Environment is everyone\'s business, everywhere, everyday.' | translate}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>



<section class="chiffres mt-0">
        <div class="container py-5">
            <div class="row all-cards text-justify-center py-4">
                <div class="col-md-6 mb-4">
                    <div class="block-safety block p-4">
                        <div class="d-flex align-items-center">
                          <div class="icon icon-center">
                            <app-svg-icon [src]="'assets/svg/users-solid.svg'" [size]="'30px'"></app-svg-icon>
                           </div>
                        </div>
                        <div class="mt-3">
                            <div class="nb">{{(valueDatas['employees'] ? valueDatas['employees'] : 0)}}</div>
                            <div class="desc mt-2">{{'Trainees' | translate}}</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 mb-4">
                    <div class="block-safety block p-4">
                        <div class="d-flex align-items-center">
                          <div class="icon icon-center">
                              <app-svg-icon [src]="'assets/svg/handshake-solid.svg'" [size]="'30px'"></app-svg-icon>
                          </div>
                        </div>
                        <div class="mt-3">
                          <div class="nb">{{(valueDatas['partner'] ? valueDatas['partner'] : 0)}}</div>
                          <div class="desc mt-2">{{'Campus' | translate}}</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 mb-4 mb-md-0">
                    <div class="block-safety block p-4">
                        <div class="d-flex align-items-center">
                          <div class="icon icon-center">
                              <app-svg-icon [src]="'assets/svg/VR_Casque_Plein.svg'" [size]="'30px'"></app-svg-icon>
                          </div>
                        </div>
                        <div class="mt-3">
                          <div class="px-4">
                            <div class="nb">{{(valueDatas['projects'] ? valueDatas['projects'] : 0)}}</div>
                            <div class="desc mt-2">{{'EHS VR workshops' | translate}}</div>
                          </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="block-safety block p-4">
                        <div class="d-flex align-items-center">
                          <div class="icon icon-center">
                              <app-svg-icon [src]="'assets/svg/chalkboard-teacher-solid.svg'" [size]="'30px'"></app-svg-icon>
                          </div>
                        </div>
                        <div class="mt-3">
                          <div class="px-4">
                            <div class="nb">{{(valueDatas['vr_formations'] ? valueDatas['vr_formations'] : 0)}}</div>
                            <div class="desc mt-2">{{'QEHS trainings' | translate}}</div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</section>


<section class="certifications light-grey py-5">
  <div class="container">
    <div class="row">
      <div class="col-md-6 col-12 mb-0 border-custom pb-md-0 pb-4">
        <div class="d-flex justify-content-center align-items-center">
            <div class="blue-icon mr-md-5 mr-3">
                <app-svg-icon [src]="'assets/svg/cybersecurity.svg'" [size]="'60px'"></app-svg-icon>
            </div>
                <p class="text-left etudeTitle m-0 p-0 max-w-custom">{{'Cyber Security Certification' | translate}}</p>
        </div>
      </div>
      <div class="col-md-6 col-12 d-flex align-items-center justify-content-center flex-wrap pt-md-0 pt-4 gap-custom">
        <ng-container *ngFor="let logo of certifications">
            <picture *ngIf="!logo.isSVG">
                <source srcset="{{logo.src}}.webp" type="image/webp">
                <source srcset="{{logo.src}}.png" type="image/png">
                <img src="{{logo.src}}.png" alt="{{logo.alt}} logo" title="{{logo.title}}" [attr.width]="logo.width" loading="lazy"/>
            </picture>
            <img *ngIf="logo.isSVG" src="{{logo.src}}.svg" alt="{{logo.name}} logo" title="{{logo.name}}" [attr.width]="logo.width" loading="lazy"/>
        </ng-container>
      </div>
    </div>
  </div>
</section>


<section class="timeline mt-5 pt-4 pb-2">
    <h3 class="mb-5">{{'Our growth through the time' | translate}}</h3>
    <div class="container timeline-container">
        <div class="left-arrow" (click)="slidePrev()">
            <div class="timeline-prev"></div>
            <div class="timeline-desc">{{'older' | translate}}</div>
        </div>
        <div class="left-stris stris">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        <swiper *ngIf="displayMap" [config]="timelineConfig" class="mb-5">
            <div class="swiper-wrapper">
                <div class="swiper-slide" *ngFor="let y of timeline;let i = index">
                    <div class="item">
                        <div class="item-icon">
                            <app-svg-icon [src]="'assets/svg/'+y.icon+'.svg'" [size]="'28px'"></app-svg-icon>
                        </div>
                        <div class="item-date">{{y['date']}}</div>
                        <div class="timeline-bar"></div>
                        <div class="item-desc" [ngClass]="{'border-0' : i >= timeline.length-1}">
                            <p class="mb-1 text-center" *ngFor="let i of y['content'][translate.store.currentLang]" [innerHTML]="i"></p>
                        </div>
                    </div>
                </div>
            </div>
        </swiper>
        <div class="right-arrow" (click)="slideNext()">
            <div class="timeline-next"></div>
            <div class="timeline-desc">{{'newer' | translate}}</div>
        </div>
        <div class="right-stris stris">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>

    </div>

</section>

<!-- <section class="citation">
    <div class="citation-text">
        <h3>
            « {{'Tell me and I forget.' | translate}}<br>
            {{'Teach me and I remember.' | translate}}<br>
            {{'Involve me and I learn' | translate}} »
        </h3>
        <h5 class="text-right mb-0"><i>Benjamin Franklin</i></h5>
    </div>
</section> -->

<hr>

<section class="etudePwc mt-5">
        <div class="container py-5">
            <p class="text-center mb-4 etudeTitle">{{'Une étude menée par PwC en 2020 montre que les apprenants formés grâce à l’apprentissage immersif étaient jusqu’à :' | translate}}</p>
            <div class="row all-cards">
                <div class="col-md-5 mb-4 image-banner">
                    <div class="block-safety block p-4 banner">
                    </div>
                </div>
                <div class="col-md-7 mb-4">
                    <div class="row all-cards text-justify-center">
                        <div class="col-md-6 mb-4">
                            <div class="block-safety block p-4">
                                <div class="d-flex align-items-center">
                                  <div class="icon icon-center">
                                    <i class="fas fa-brain icon-i"></i>
                                   </div>
                                </div>
                                <div class="mt-3">
                                    <div class="nb">4x</div>
                                    <div class="desc mt-2 px-2">{{'plus concentrés que leurs homologues en e-learning' | translate}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 mb-4">
                            <div class="block-safety block p-4">
                                <div class="d-flex align-items-center">
                                  <div class="icon icon-center">
                                      <app-svg-icon [src]="'assets/svg/brain-solid.svg'" [size]="'30px'"></app-svg-icon>
                                  </div>
                                </div>
                                <div class="mt-3">
                                  <div class="nb">1,5x</div>
                                  <div class="desc mt-2 px-2">{{'plus concentrés qu’en suivant une formation classique' | translate}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 mb-4 mb-md-0">
                            <div class="block-safety block p-4">
                                <div class="d-flex align-items-center">
                                  <div class="icon icon-center">
                                    <i class="fas fa-tachometer-alt icon-i"></i>
                                  </div>
                                </div>
                                <div class="mt-3">
                                  <div class="px-4">
                                    <div class="nb">4x</div>
                                    <div class="desc mt-2 px-2">{{'plus rapides à retenir l’information qu’en classe traditionnelle' | translate}}</div>
                                  </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="block-safety block p-4">
                                <div class="d-flex align-items-center">
                                  <div class="icon icon-center">
                                      <app-svg-icon [src]="'assets/svg/graduation-cap-solid.svg'" [size]="'30px'"></app-svg-icon>
                                  </div>
                                </div>
                                <div class="mt-3">
                                  <div class="px-4">
                                    <div class="nb">275%</div>
                                    <div class="desc mt-2 px-2">{{'plus confiants pour appliquer les compétences acquises' | translate}}</div>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</section>


<hr class="mb-0">



<section id="accordion" *ngIf="teamMembers" class="our-team py-5 mt-0">
    <!-- <div class="head-icon">
        <app-svg-icon [src]="'assets/svg/users-cog-solid.svg'" [size]="'30px'"></app-svg-icon>
    </div> -->
    <!-- <h3 class="text-center font-weight-bold mt-4 text-uppercase mb-0">{{'Our team' | translate}}</h3> -->
    <div class="container" style="max-width: 1000px;">

        <div *ngFor="let pole of teamMembers; let i = index" class="mt-4">
            <div *ngIf="pole.name" class="team-title">{{pole.name}}</div>

            <div class="row m-0">
                <ng-container *ngFor="let chunkMembers of pole['chunkMembers']; let j = index">
                    <div *ngFor="let membre of chunkMembers; let k = index" class="col-6 col-md-3 p-0 mb-2">
                        <div class="team-member">
                            <div [ngClass]="{'pointer': membre.description}" class="team-member-img" data-toggle="collapse" [attr.data-target]="checkDescription(membre, i, j, k)" aria-expanded="false" aria-controls="collapse{{i}}-{{j}}-{{k}}">
                                <img *ngIf="membre.transparentPhoto" src="{{membre.transparentPhoto}}" alt="Photo of {{membre.name}}, member of Immersive Factory team" title="{{membre.name}} photo" loading="lazy">
                            </div>
                            <p *ngIf="membre.name" class="mb-0 font-weight-bold text-center">{{membre.name}}</p>
                            <p *ngIf="membre.title" class="mb-0 text-center">{{membre.title}}</p>
                        </div>
                    </div>
                    <div *ngFor="let membre of chunkMembers; let k = index" class="col-12 px-0">
                        <div id="collapse{{i}}-{{j}}-{{k}}" class="collapse" data-parent="#accordion">
                            <div class="position-relative mb-4 mt-1">
                                <div class="team-close" (click)="closeAllCollapses()">×</div>
                                <div class="row">
                                    <div class="col-12 col-md-4">
                                        <img *ngIf="membre.photo" src="{{membre.photo}}" class="teamphoto" alt="Colour photo of {{membre.name}}, member of Immersive Factory team" title="{{membre.name}} colour photo" loading="lazy">
                                    </div>
                                    <div class="col-12 col-md-8 col-desc px-2 mt-4">
                                        <div *ngIf="membre.name" class="team-name">{{membre.name}}</div>
                                        <div *ngIf="membre.title" class="team-status">{{membre.title}}</div>
                                        <div *ngIf="membre.description" class="team-desc px-lg-5">
                                            {{membre.description}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

            </div>

        </div>

    </div>
</section>


<hr>

<app-they-trust-us></app-they-trust-us>

<hr>

<section class="pt-3 pb-5">
  <app-featured-news></app-featured-news>
</section>

<div class="modal fade" tabindex="-1" role="dialog" id="contact-modal" aria-labelledby="contactModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">

        <div class="container">
          <div class="row">

            <div class="col-xl-5 col-lg-6 col-12 img-banner">
              <div class="blue-background">
                <div class="infos-content d-flex flex-column justify-content-between py-4 px-custom h-custom">

                  <div class="d-lg-block d-none">
                    <h5 class="font-weight-bold">{{'Entrons en contact' | translate}}</h5>
                  </div>
                  <div class="d-lg-none d-block d-flex align-items-start justify-content-between">
                    <h5 class="font-weight-bold pr-2">{{'Entrons en contact, nous vous rappellerons dans les plus brefs délais' | translate}}</h5>
                    <button type="button" class="close" (click)="hideModalContact()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  <div class="d-flex align-items-center mb-lg-0 mb-2">
                    <app-svg-icon [src]="'assets/svg/envelope-light.svg'" [size]="'50px'" class="fas d-lg-block d-none contact-icon mr-4"></app-svg-icon>
                    <app-svg-icon [src]="'assets/svg/envelope-light.svg'" [size]="'25px'" class="fas d-lg-none d-block contact-icon mr-3"></app-svg-icon>
                    <div class="d-lg-block d-none">{{'Pour toutes demandes commerciales, remplissez le formulaire ci-contre' | translate}} <i class="ml-1 fas fa-long-arrow-alt-right fa-lg"></i></div>
                    <div class="d-lg-none d-block">{{'Pour toutes demandes commerciales, remplissez le formulaire ci-dessous' | translate}}</div>
                  </div>
                  <div class="d-flex align-items-center mb-lg-0 mb-2">
                    <app-svg-icon [src]="'assets/svg/comment-dots-light.svg'" [size]="'50px'" class="fas d-lg-block d-none contact-icon mr-4"></app-svg-icon>
                    <app-svg-icon [src]="'assets/svg/comment-dots-light.svg'" [size]="'25px'" class="fas d-lg-none d-block contact-icon mr-3"></app-svg-icon>
                    <div>
                        <span class="mr-2">{{'Pour toutes autres demandes' | translate}}</span>
                        <div class="bg-immersive btn-chat-with-us woot-widget-bubble woot-widget--expanded__text mt-1" (click)="openChat()">

                            {{'Discuter avec nous' | translate}}
                        </div>
                    </div>
                  </div>
                  <!-- <div class="d-flex align-items-center mb-lg-0 mb-2">
                    <app-svg-icon [src]="'assets/svg/comment-dots-light.svg'" [size]="'50px'" class="fas d-lg-block d-none contact-icon mr-4"></app-svg-icon>
                    <app-svg-icon [src]="'assets/svg/comment-dots-light.svg'" [size]="'25px'" class="fas d-lg-none d-block contact-icon mr-3"></app-svg-icon>
                    <div>{{'Pour toutes autres demandes, contactez nous via le chat en bas de l’écran' | translate}}</div>
                  </div> -->
                  <!-- <div class="d-flex align-items-center">
                    <app-svg-icon [src]="'assets/svg/briefcase-light.svg'" [size]="'50px'" class="fas d-lg-block d-none contact-icon mr-4"></app-svg-icon>
                    <app-svg-icon [src]="'assets/svg/briefcase-light.svg'" [size]="'25px'" class="fas d-lg-none d-block contact-icon mr-3"></app-svg-icon>
                    <div>{{'Pour postuler, rendez-vous' | translate}} <span class="url" [routerLink]="language.navigateAccordingToLang(['/jobs'])">{{'sur cette page' | translate}}</span></div>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="modal-content col-xl-7 col-lg-6 col-12">
                <div class="modal-header border-0">
                    <h5 class="modal-title" id="contactModalLabel">{{'Laissez-nous vos coordonnées' | translate}}</h5>
                    <button type="button" class="close d-lg-block d-none" (click)="hideModalContact()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body px-3 pb-3 pt-0">
                    <contact-form
                        (formSuccess)="hideModalContact()"
                        [prefillFields]="prefillFields"
                        [formId]="'contact'"
                        [removeFields]="contactFormHiddenInputs"
                        [autoFill]="true"
                        *ngIf="modalIsOpen()"
                        [additionalInfos]="mapDotClicked ? [{id:'mapDot', value:mapDotClicked.id}] : null"
                    ></contact-form>
                </div>
            </div>

          </div>
        </div>

    </div>
</div>
